import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, Zap, CheckCircle2 } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function PricingSection() {
  const handleCheckoutClick = () => {
    trackAddToCart();
  };
  return <section id="comprar" className="py-24 px-4 relative overflow-hidden bg-slate-900 border-t border-slate-800" data-id="element-175">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-blue-900/15 rounded-full blur-[150px] -z-10 pointer-events-none" data-id="element-176"></div>

      <div className="max-w-5xl mx-auto" data-id="element-177">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-178">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-179">
            Acceso Inmediato al Protocolo Completo
          </h2>
          <p className="text-xl text-slate-400" data-id="element-180">
            Obtén el "Interruptor de Nitrógeno" Hoy
          </p>
        </motion.div>

        <div className="max-w-md mx-auto bg-slate-950 border border-slate-700 rounded-3xl shadow-2xl overflow-hidden relative mb-16" data-id="element-181">
          {/* Highlight top bar */}
          <div className="h-2 w-full bg-gradient-to-r from-blue-600 via-blue-400 to-blue-600" data-id="element-182"></div>

          <div className="p-8 flex flex-col items-center" data-id="element-183">
            <div className="text-center mb-8 w-full" data-id="element-184">
              <div className="flex justify-center items-center gap-3 mb-2" data-id="element-185">
                <span className="text-slate-500 text-xl line-through decoration-red-500/50 decoration-2" data-id="element-186">
                  $59.99 USD
                </span>
                <span className="bg-emerald-500/20 text-emerald-400 text-sm font-bold px-3 py-1 rounded-full border border-emerald-500/30" data-id="element-187">
                  🔥 Ahorras $45.00 USD
                </span>
              </div>
              <div className="text-6xl font-extrabold text-amber-500 drop-shadow-[0_0_15px_rgba(245,158,11,0.3)] mb-2" data-id="element-188">
                $14.99 <span className="text-3xl" data-id="element-189">USD</span>
              </div>
              <p className="text-blue-400 font-medium text-sm mt-2" data-id="element-190">
                Acceso inmediato al protocolo completo + 4 bonos exclusivos.
              </p>
            </div>

            <div className="w-full mb-8" data-id="element-191">
              <h4 className="text-white font-bold mb-4 text-center" data-id="element-192">
                ¿Qué Incluye?
              </h4>
              <ul className="space-y-3" data-id="element-193">
                {['Manual PDF completo del Protocolo 7 Minutos', 'Bono #1: Checklist Previa al Momento', 'Bono #2: Guía de Alimentos que Juegan a Favor', 'Bono #3: Script Mental de Calma y Control', 'Bono #4: Tracker de Progreso y Señales de Mejora', 'Acceso de por vida a actualizaciones', 'Garantía de 30 días'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-300" data-id="element-194">
                    <CheckCircle2 className="w-5 h-5 text-blue-500 shrink-0" data-id="element-195" />
                    <span data-id="element-196">{item}</span>
                  </li>)}
              </ul>
            </div>

            <a href="https://pay.hotmart.com/N106214049R?checkoutMode=10" onClick={handleCheckoutClick} className="w-full flex justify-center items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-bold text-lg py-5 px-6 rounded-2xl transition-all duration-300 shadow-[0_0_25px_rgba(37,99,235,0.5)] hover:shadow-[0_0_40px_rgba(37,99,235,0.7)] hover:scale-105 active:scale-95 mb-4 text-center" data-id="element-197">
              <Zap className="w-6 h-6 shrink-0" data-id="element-198" />
              DESCARGAR PROTOCOLO + BONOS AHORA
            </a>

            <div className="flex flex-col items-center gap-3 text-xs text-slate-400 w-full text-center" data-id="element-199">
              <p className="text-slate-300 font-medium" data-id="element-200">
                Incluye el ebook principal, checklist, guía de alimentos, script
                mental y tracker de progreso.
              </p>
              <p className="mt-2" data-id="element-201">
                Acceso inmediato - Pago 100% seguro - Disponible 24/7
              </p>
              <div className="flex flex-wrap justify-center gap-4 mt-2" data-id="element-202">
                <div className="flex items-center gap-1" data-id="element-203">
                  <Lock className="w-4 h-4 text-emerald-500" data-id="element-204" />
                  <span data-id="element-205">Pago encriptado y discreto</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-206">
                  <Zap className="w-4 h-4 text-blue-500" data-id="element-207" />
                  <span data-id="element-208">Recibes acceso en &lt; 2 min</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-209">
                  <ShieldCheck className="w-4 h-4 text-amber-500" data-id="element-210" />
                  <span data-id="element-211">Garantía de 30 días</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl mx-auto text-center" data-id="element-212">
          <div className="bg-blue-900/10 border border-blue-500/20 rounded-2xl p-6 mb-10 text-left" data-id="element-213">
            <p className="text-slate-300 leading-relaxed" data-id="element-214">
              <span className="text-blue-400 font-bold" data-id="element-215">
                Este no es solo un ebook.
              </span>{' '}
              Es un sistema completo de 7 días con herramientas prácticas para
              entender qué hacer, cómo prepararte, qué medir y cómo mantener el
              control mental durante el proceso.
            </p>
          </div>

          <h3 className="text-2xl font-bold text-white mb-6" data-id="element-216">
            ÚLTIMA LLAMADA: Piénsalo.
          </h3>
          <div className="grid sm:grid-cols-2 gap-8 mb-8 text-left" data-id="element-217">
            <div className="bg-slate-950 p-6 rounded-2xl border border-slate-800" data-id="element-218">
              <p className="text-slate-400 mb-3 font-medium" data-id="element-219">
                $14.99 USD es lo que cuesta:
              </p>
              <ul className="space-y-2 text-slate-500" data-id="element-220">
                <li data-id="element-221">• Una cena rápida</li>
                <li data-id="element-222">• Dos pastillas de marca</li>
                <li data-id="element-223">• Una salida al cine</li>
              </ul>
            </div>
            <div className="bg-blue-900/20 p-6 rounded-2xl border border-blue-500/30" data-id="element-224">
              <p className="text-blue-400 mb-3 font-medium" data-id="element-225">
                Pero esta inversión puede devolverte:
              </p>
              <ul className="space-y-2 text-slate-200" data-id="element-226">
                <li data-id="element-227">• Tu confianza</li>
                <li data-id="element-228">• Tu control</li>
                <li data-id="element-229">• Tu tranquilidad mental</li>
                <li data-id="element-230">• Tu vida íntima</li>
              </ul>
            </div>
          </div>
          <p className="text-lg text-slate-300 mb-8" data-id="element-231">
            La pregunta no es "¿puedo permitirme esto?"
            <br data-id="element-232" />
            <span className="text-white font-bold" data-id="element-233">
              La pregunta es "¿puedo permitirme seguir como estoy?"
            </span>
          </p>
          <a href="https://pay.hotmart.com/N106214049R?checkoutMode=10" onClick={handleCheckoutClick} className="inline-flex justify-center items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(37,99,235,0.4)] hover:shadow-[0_0_30px_rgba(37,99,235,0.6)] hover:scale-105 active:scale-95" data-id="element-234">
            👉 Descargar Protocolo + Bonos Ahora
          </a>
          <p className="text-slate-500 text-sm mt-4" data-id="element-235">
            Descarga inmediata - $14.99 USD
          </p>
        </motion.div>
      </div>
    </section>;
}